module.exports = __webpack_public_path__ + "img/gch3@2x.2501b7dc.png";